import BaseComponent from '../../../base/base_component';
import {SYSTEM_EVENTS} from '../../../events/events';
import {MESSAGE_TYPE} from '../../message/message_consts';
import Event from '../../../utils/event';
import {PRIORITY_LEVEL} from '../../../services/overlay_manager/overlay_manager_levels';

class BaseOptionsComponentController extends BaseComponent {

    static CLASS = 'BaseOptionsComponentController';

    /**
     * Render Component UI over Overlay
     *
     * @returns
     * @public
     */
    render() {
        if (this.start()) {
            //this._openInOverlay();
            this._openInMDP();

        }
    }


    _openInOverlay() {
        Event.fire(SYSTEM_EVENTS.OPEN_OVERLAY, {
            el: this.getEl(),
            priority: this.getOverlayPriority(),
            btnCloseCallback: () => {
                this.onCloseBtnClicked();
                },
            closeCallback: () => {
                this.onComponentClosed();
                },
            additionalClasses: ['cgp-options-component', 'cgp-mdp-dialog'],
            contentAdditionalClasses: ['cgp-theme-property-lb-corner-radius'],
            openCallback: () => {
                this._onComponentOpened();
            }
        });
    }


    /**
     * Open component over MDP message
     * @private
     */
    _openInMDP() {
        Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
            contentEl: this.getEl(),
            title: this._getOptionTitle(),
            closeButton: this._isCloseButtonEnabled(),
            hasDefaultButton: false,
            customCSSClassList: this._getCustomCSSClassList(),
            priority: this.getOverlayPriority(),
            buttons: this._getButtons(),
            openCallback: this.onComponentOpened.bind(this),
            closeCallback: this.onComponentClosed.bind(this),
            btnCloseCallback: this.onCloseBtnClicked.bind(this)
        });
    }


    /**
     * Get Custom CSS to create spicified selectors for option component
     * @returns {Array}
     */
    _getCustomCSSClassList() {
        return ['cgp-options-component', 'mdp-mobile-full-size'];
    }

    /**
     * close button display - the default is true
     */
    _isCloseButtonEnabled() {
        return true;
    }

    /**
     * Get option title. This title will be displayed in the title area of MDP
     */
    _getOptionTitle() {
        let titleLangKey = this._getTitleKey();
        if (titleLangKey) {
            return this.serviceFactory.languageService().translation(titleLangKey);
        }
        return '';
    }


    /**
     * Get buttons configuration to MDP
     * @returns {Array}
     * @private
     */
    _getButtons() {
        return [];
    }

    /**
     * @abstract
     * Get title language key
     * @private
     */
    _getTitleKey() {}

    /*
    * Remove Componwent UI from overlay
    * @depricated
    * @returns
    * @public
    */
    destroy() {
        Event.fire(SYSTEM_EVENTS.CLOSE_OVERLAY, {priority: this.getOverlayPriority()});
    }

    /**
     * Open error message dialog
     * @param text
     */
    openErrorMessage(text) {
        Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {text: text, type: MESSAGE_TYPE.ERROR});
    }

    /**
     * Get options from model
     * @returns {object}
     */
    getOptions() {
        return this._model.getOptions();
    }


    /**
     * Get priority to option message
     * @returns {number}
     */
    getOverlayPriority() {
        return PRIORITY_LEVEL.POP_UP;
    }


    /**
     * Handle after component open action
     * @abstract
     * @protected
     */
    onComponentOpened() {}


    /**
     * Handle action on btn close clicked
     */
    onCloseBtnClicked() {}


    /**
     * Handle action after component was closed
     */
    onComponentClosed() {
        this.shutDown();
    }

    /**
     * Send analytcs message
     */
    reportAnalytics() {

    }

}

export default  BaseOptionsComponentController;

